import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { PermissionCheck } from "../../shared/permission";

let DummyDataBannerComponent = {
    selector: "vcDummyDataBanner",
    templateUrl:
        "/angular/components/dummy-data/dummy-data-banner.component.html",
    bindings: {
        enableLocation: "=?",
        needsDivider: "=?",
    },
    controller: class DummyDataBannerController {
        // * bindings for typescript compiler *
        public enableLocation?: string;
        public needsDivider?: boolean;
        // ************************************

        private $window: any;
        private dialog: DialogUtils;
        private campaignDataProvider: CampaignDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            $window: any,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$window = $window;
            this.dialog = DialogUtils;
            this.campaignDataProvider = CampaignDataProvider;
            this.permissionProvider = PermissionCheck;

            this.campaignDataProvider.hasSampleData().then((hasSampleData) => {
                if (!hasSampleData) {
                    this.campaignDataProvider.allowedToEnableSampleData();
                }
            });
        }

        $onInit() {}

        deleteDummyData($event: any) {
            let buttonText = this.enableLocation ?? '"Actions"';
            this.dialog
                .delete({
                    targetEvent: $event,
                    locals: {
                        bodyText:
                            "<p>Are you sure you want to remove this sample data?  " +
                            "This will remove your sample contacts, houses, interactions etc.</p>" +
                            "<p> Don't worry, if you change your mind you can restore this" +
                            " sample data within the " +
                            buttonText +
                            " dropdown</p>",
                        title: "Clear sample data?",
                    },
                })
                .then(() => {
                    this.campaignDataProvider.deleteSampleData().then(() => {
                        this.$window.location.reload();
                    });
                });
        }
    },
};

angular
    .module("dummyData", [])
    .component(DummyDataBannerComponent.selector, DummyDataBannerComponent);
